import { IDataConfigSdl } from "../../components/types/Types";
import getFetchUrl from "../getFetchUrl";

const fetchSdlDataConfig = async (listView: string, configType: string) =>
  await fetch(getFetchUrl(), {
    method: "POST",

    body: JSON.stringify({
      query: `query{
        items(
          filter: {itemTypes: [COMPONENT], namespaceIds: [1],  
          and:[
           { customMeta: {key: "ApplicationTag", value: "openpages"}},
             { customMeta: {key: "ApplicationPageTag", value: "${listView}"}}, 
            { customMeta: {key: "ApplicationContentTag", value: "${configType}"}}]}
        ) {
          edges {
            node {
                ... on Component {
                content {
                    ... on UntypedContent {
                    data
                    }
                }
                }
            }
            }
        }
      }`,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response: Response) => {
      return response.json();
    })
    .then((responseJson: IDataConfigSdl) => {
      return responseJson;
    })
    // eslint-disable-next-line no-console
    .catch((error) => {
      throw new Error(`Could not get config ${error}`);
    });
export default fetchSdlDataConfig;
